import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import dummyMesgIntro from "../../../../features/Chat/__dummy__/dummyMesgIntro";
import dummyMesgBot from "../../../../features/Chat/__dummy__/dummyMesgBot";
import erody from "../../../../assets/erody_chat.svg";
import messageCardArray from "../../../../features/Chat/__dummy__/messageCardArray";
import messageMap from "../../../../features/Chat/__dummy__/messageMap";

// Initial state
const initialState = {
  data: null,
  error: false,
  loading: false,
  loaded: false,
  message: null,
  messageList: [],
};

// Slice
const qaSlice = createSlice({
  name: "qa",
  initialState,
  reducers: {
    initQa(state) {
      return {
        ...state,
        data: null,
        error: false,
        loading: false,
        loaded: false,
        message: null,
        messageList: [],
      };
    },
    qaStart(state) {
      return { ...state, loading: true, error: false, loaded: false };
    },

    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
    setMessage(state, action) {
      const { message } = action.payload;
      return {
        ...state,
        message,
      };
    },
    setMessageList(state, action) {
      const transformedData = action.payload;
      return {
        ...state,
        messageList: [...state.messageList, transformedData],
      };
    },
  },
});

export const {
  initQa,
  qaStart,
  fetchDataSuccess,
  fetchDataFailure,
  setMessage,
  setMessageList,
} = qaSlice.actions;

export default qaSlice.reducer;

//API 샌드버드 데이터 스트럭쳐로 수정
const formatMesgData = (type, content, userId) => {
  const sender = {
    userId: "erody",
    plainProfileUrl: erody,
    nickname: "이로디",
    type: type,
  };
  let data = "";
  if (type === "USER") {
    sender.userId = userId;
    sender.nickname = "고객";
    data = { role: "USER" };
  } else {
    data = { role: "BOT" };
  }

  const makeCard = ({ content }) => {
    const data = content.map((item) => {
      if (item.type === "text") {
        return {
          type: "card",
          value: [
            {
              type: "text",
              value: item.value,
            },
          ],
        };
      }
      return item;
    });
    return data;
  };

  const getMesgAndBtns = (content, type) => {
    const textItem = content?.find((item) => item.type === "text");
    const cardItem = content?.find((item) => item.type === "card");

    let message = "";
    if (textItem) {
      message = textItem.value;
    } else if (cardItem) {
      const textCard = cardItem.value.find((card) => card.type === "text");
      if (textCard) {
        message = textCard.value;
      }
    }

    const buttons = cardItem
      ? cardItem.value.flatMap((card) =>
          type === "INTRO_MESG" || card.type === "buttons" ? card.value : []
        )
      : [];

    return { message, buttons };
  };

  if (["INTRO_MESG", "BOT", "REALTIME_ISSUE", "USER"].includes(type)) {
    const card = makeCard({ content });
    const { message, buttons } = getMesgAndBtns(card, type);

    return {
      data,
      card,
      sender,
      message,
      buttons,
      createdAt: new Date().getTime(),
    };
  }

  return {};
};

function isJSONString(str) {
  if (typeof str === "number" || !isNaN(Number(str))) return false;
  if (typeof str !== "string") return false;
  try {
    JSON.parse(str);
    return true;
  } catch (error) {
    return false;
  }
}

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  const tempUserId = yield select((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(" ", "+");
  const sender = {
    userId,
    plainProfileUrl: erody,
    nickname: "고객",
    type: "USER",
  };

  try {
    const { headers = {}, apiUrl, data } = action.payload;
    if (isJSONString(data?.message) !== true) {
      const { message } = data;
      const createdAt = new Date().getTime();
      const card = [
        {
          type: "card",
          value: [
            {
              type: "text",
              value: message,
            },
          ],
        },
      ];

      yield put(setMessageList({ sender, card, message, createdAt, data: "" }));
      // yield put(setMessageList({ sender, message, createdAt, data: "" }));
    } else {
      const parsedMessage = JSON.parse(data.message);

      if (parsedMessage?.type !== "GREET_RESPOND_NORMAL") {
        const { message } = parsedMessage;
        const createdAt = new Date().getTime();
        const card = [
          {
            type: "card",
            value: [
              {
                type: "text",
                value: message,
              },
            ],
          },
        ];
        yield put(
          setMessageList({ sender, card, message, createdAt, data: "" })
        );
      }
    }
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      },
    });

    const response = yield call(apiService.post, apiUrl, data);

    yield put(fetchDataSuccess(response.data));

    if (response?.data) {
      const { data } = response;
      yield put(setMessage({ message: data }));
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

function* formatMsgSaga(action) {
  const tempUserId = yield select((state) => state.checkArsStatus.userId);
  const userId = tempUserId??"".replaceAll(" ", "+");

  const { message } = action.payload;
  const transtormedData = formatMesgData(
    message?.type,
    message?.content,
    userId
  );
  yield put(setMessageList(transtormedData));
}

// API 호출을 감시하는 Saga 함수
export function* qaSaga() {
  yield takeLatest(qaStart.type, fetchDataSaga);
  yield takeLatest(setMessage.type, formatMsgSaga);
}
